import { createContext, useContext, useState, useMemo, ReactNode } from "react";

interface LoadingContextType {
    isGlobalLoading: boolean;
    setGlobalLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

interface LoadingProviderProps {
    children: ReactNode;
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
    const [isGlobalLoading, setGlobalLoading] = useState(false);

    // Memoizing to prevent unnecessary renders
    const value = useMemo(() => ({ isGlobalLoading, setGlobalLoading }), [isGlobalLoading]);

    return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoading must be used within a LoadingProvider");
    }
    return context;
};
